"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var getMissingChallengePreregistrationConfig = function getMissingChallengePreregistrationConfig(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$registrationConf = _ref.registrationConfig,
      registrationConfig = _ref$registrationConf === void 0 ? [] : _ref$registrationConf;
  return Object.keys(registrationConfig).reduce(function (acc, item) {
    var keyTofind = registrationConfig[item];
    var userProperty = (0, _get["default"])({
      user: user
    }, keyTofind);

    if (!userProperty) {
      acc.push(item);
    }

    return acc;
  }, []);
};

var _default = getMissingChallengePreregistrationConfig;
exports["default"] = _default;
//# sourceMappingURL=getMissingChallengePreregistrationConfig.js.map